
<span class="c-header__slot">
  <div
    data-testid="button-bar-navigation-menu"
    @click="toggleCategoryMenu(true)"
  >
    <vIcon
      name="hamburguer"
      color="primary"
    />
  </div>

  <vHeaderMenu
    :should-show-menu="shouldShowCategoryMenu"
    :should-schedule-menu-hide="false"
    position="left"
    @close-menu="toggleCategoryMenu(false)"
  >
    <vCategoryMenu
      :tree="categoryTree"
    />
  </vHeaderMenu>
</span>
